<template>
  <div>

    <div v-if="checkVisibleProducts.length <= 0" class="no-offer">
      <div class="txt-container">
        <p class="mb-0">
          Pronto veras las ofertas disponibles 😌
        </p>
      </div>
    </div>

    <div id="wrapProductos" class="productos_list" v-if="checkVisibleProducts.length > 0">
      <div class="content-info-counter">
        <!-- <Timer :deadline="fechaOfertas" /> -->
      </div>
      <div class="content-products">
        <div class="producto" v-for="(item) in productos" v-bind:key="item.id" :id="item.id" :orden="item.orden"
          :class="[(item.visible == false ? 'd-none' : ''), (item.destacado ? 'item-destacado' : '')]">

          <div @click="trackProductos(item)" class="wrap" :class="item.agotado ? 'disabled' : ''">
            <img :src="item.imagen" class="img-producto" :alt="item.titulo" />
            <div class="destacado" v-if="item.destacado"></div>
            <div class="agotado" v-if="item.agotado">agotado</div>
          </div>


        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { RouterLink } from "vue-router";
import fire from "./../fire";
import Timer from "@/components/Timer";
export default {
  components: { Timer },
  data() {
    return {
      productos: [],
      current: null,
      modal1: true,
      modal2: false,
      oferta: '',
      selected: '',
      selectedMemory: '',
      selectedColors: '',
      selectedColor: '',
      selectedConn: '',
      shopURL: '',
      bgfade: false,
      marcado: '',
      activePack: '',
      shopBtn: true,
      productsCount: null,
      fechaOfertas: new Date("2023/04/18 21:00:00")
    };
  },
  methods: {
    scrollToAnchor(idAnchor) {
      const initialCharDetector = /#/i;
      if (idAnchor.match(initialCharDetector)) {
        let cleanedAnchor = idAnchor.slice(1);
        window.parent.postMessage({ type: 'scrollToAnchor', anchor: cleanedAnchor }, '*');
        console.log(`Clicked Item:  ${cleanedAnchor}`);
      } else {
        console.log('The url is not an anchor');
        return
      }

    },
    trackProductos(item) {
      if (!item.agotado) {
        fire.analytics().logEvent('oferta_' + item.orden, { item_id: 'button_click', item_name: 'oferta_' + item.orden });
        fire
          .database()
          .ref("productos/" + item.id)
          .update(
            {
              count: this.productsCount[item.id].count + 1
            },
            function (error) {
              if (error) {
                console.log("error saving");
              } else {
                console.log("saved");
              }
            }
          );
        const initialCharDetector = /#/i;

        if (item.url[0].match(initialCharDetector)) {
          this.scrollToAnchor(item.url);
          return
        }

        if (item.url && item.url != "#") {
          window.open(item.url, '_blank').focus();
        } else {
          return false;
        }
      }
    },
    goProduct(item) {
      fire.analytics().logEvent(this.selected.titulo);
      this.shopURL = item.url
    },
    async loadProducts() {
      let ref = this;
      const itemsRef = fire.database().ref("productos").orderByChild('orden');
      let fin = await itemsRef.on("value", snapshot => {
        let data = snapshot.val();
        let productos = [];
        Object.keys(data).forEach(key => {
          productos.push({
            id: key,
            count: 0,
            nombre: data[key].nombre,
            url: data[key].url,
            slug: data[key].slug,
            colores: data[key].colores,
            visible: data[key].visible,
            imagen: data[key].imagen,
            orden: data[key].orden,
            agotado: data[key].agotado,
            destacado: data[key].destacado
          });
        });
        ref.productos = productos.sort((a, b) => a.orden < b.orden ? -1 : Number(a.orden > b.orden))
        // console.log('pimedo:', ref.productos[0].id)
      });
      return fin;
    },
    cerrar() {
      this.modal1 = false
      this.modal2 = false
      this.bgfade = false
      this.selected = ''
      this.selectedMemory = ''
      this.selectedColor = ''
      this.activePack = ''
      this.shopURL = ''
      this.selectedColors = ''
      this.marcado = ''
    },
    track(item) {
      //fire.analytics().logEvent(item);

      console.log(this.marcado)
    },
    trackColor() {
      fire.analytics().logEvent(this.selectedColor);
      this.marcado = this.selected.titulo + ' - ' + this.selectedColor
    },
    selectColor(color, url) {
      this.selectedColor = color
      // console.log(this.selectedColor)
      this.shopURL = url
    },
    selectMemory(memory, index) {
      this.selectedMemory = memory
      this.selectedColors = memory
      this.selectedColor = ''
      this.shopURL = ''
      this.marcado = this.selected.titulo + ' - ' + index + ' - ' + this.selectedColor
    },
    selectPack(pack) {
      this.activePack = pack
      this.shopBtn = true
    },
    volver() {
      this.activePack = '';
      this.shopURL = '';
      this.shopBtn = false;
    }
  },
  computed: {
    checkVisibleProducts: function () {
      let visibles = this.productos.filter(item => item.visible === true);
      // console.log(visibles)
      return visibles;
    }
  },
  mounted() {
    this.loadProducts();
    setTimeout(() => {
      // console.log(this.productos[0].id);
      this.current = this.productos[0].id;
    }, 5000);

    const itemsRef = fire.database().ref("productos");
    itemsRef.on("value", snapshot => {
      let data = snapshot.val();
      this.productsCount = data;
      //console.log(this.productsCount)
    });


    const configRef = fire.database().ref("config");
    configRef.on("value", snapshot => {
      let data = snapshot.val();
      this.fechaOfertas = data.fechaOfertas;
      console.log(data.fechaOfertas)
    });

  }
};
</script>

<style lang="scss" scoped>
.header-img {
  -webkit-border-top-left-radius: 10px;
  -webkit-border-top-right-radius: 10px;
  -moz-border-radius-topleft: 10px;
  -moz-border-radius-topright: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 80%;
  margin-left: 10%;
}

.linea {
  border-top: 1px solid #000000;
  width: 90%;
  opacity: 0.3;
}

.modal-body {
  border-radius: 20px;
}

.datapromo {
  background-color: #f4f4f4;
  margin: 10px;
  border-radius: 15px;
}

.modal-1 {
  padding-bottom: 20px;
  border-radius: 20px;
  pointer-events: auto;

  .versiones {
    max-height: 600px;
    overflow-y: scroll;
    padding-bottom: 50px;

    @media (max-width: 480px) {
      max-height: 450px;
    }

    .version {
      cursor: pointer;
      margin-top: 10px;
    }
  }

  h4 {
    font-size: 20px;
    text-align: center;
    width: 80%;
    margin: 0 auto;
  }
}

.backbtn {
  display: block;
  padding: 10px;
  cursor: pointer;
}

button.cerrar {
  position: absolute;
  border: 0;
  top: 9px;
  right: 10px;
  padding: 0;
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 50%;
}

button.volver {
  position: absolute;
  border: 0;
  top: 9px;
  left: 10px;
  padding: 0;
  width: 30px;
  height: 30px;
  background: none;
  border-radius: 50%;

}

hr {
  border-color: #9A2D85 !important;
}

.promo-paso1 {
  border-radius: 18px;
  margin-bottom: 10px;
  cursor: pointer;
  padding: 15px;
  max-width: 100%;
}

.codigo {
  background-image: url("../assets/img/bg-codigo.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center;
  padding: 5px;
}

.colores {
  display: flex;
  justify-content: center;
  text-align: center;

  .color {
    border: 2px solid transparent;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    margin: 0 auto;
    cursor: pointer;

    &.selected {
      border-color: black;

      span {
        border: 2px solid white;
      }
    }

    span {
      background-color: red;
      display: block;
      border-radius: 50%;
      width: 100%;
      height: 100%;
      border: 1px solid black;
    }
  }

  p {
    width: 55px;
    font-size: 0.75em;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 4px;

    @media (max-width: 480px) {
      width: 55px;
      font-size: 0.7em;
      font-weight: 600;
      line-height: 1.2;
    }
  }
}

.memorias {
  display: flex;
  justify-content: center;

  .memoria {
    border: 1px solid black;
    width: 80px;
    height: 30px;
    margin: 0 4px;
    border-radius: 8px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;

    &.selected {
      border: 3px solid black;
    }
  }
}

.colorsconnect {
  display: flex;
  justify-content: center;

  .conn {
    border: 1px solid black;
    width: 68px;
    padding-top: 4px;
    height: 30px;
    margin: 0 4px;
    border-radius: 8px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;

    &.selected {
      border: 3px solid black;
    }
  }
}

.btn-comprar {
  margin: 5px auto;
  border-radius: 20px;
  background: #000;
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  text-transform: uppercase;
  padding: 5px 20px;
  border: 1px solid #fff;
  outline: none;
  cursor: pointer;

  &:hover {
    color: #000;
    background: #fff;
    border: 1px solid #000;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.modal-footer {
  border: 0;
}

.modal-footer.desktop {
  justify-content: center;
}

.productos_list {

  padding: 10px;
  justify-content: center;
  z-index: 99;
  pointer-events: auto;

  @media only screen and (max-width: 701px) {
    height: 250px;
  }

  &::-webkit-scrollbar {
    width: 0px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    width: 0px;
  }

  .producto {
    z-index: 99;
    margin: 5px 30px;
    cursor: pointer;

    @media (max-width: 701px) {
      margin: 5px 20px;
    }

    .wrap {
      display: flex;
      justify-content: center;

      .img-producto {
        width: 80%;
        /* max-width: 350px; */
        margin-bottom: 15px;

        @media only screen and (max-width: 480px) {
          width: 100%;
          min-width: 82vw;
          display: inline-block;
          max-width: 100%;
          margin: 5px 0;
        }
      }
    }


    a.wrap {
      display: flex;
      align-items: center;
      transition: transform 0.2s;
      cursor: pointer;
      position: relative;
      justify-content: center;
      margin: 0 auto;
      z-index: 99;

      &.disabled {
        cursor: none;
        pointer-events: none;
      }

      .texto {
        width: 62%;
        font-size: 13px;
        line-height: 17px;
        margin-left: 1%;
      }

      .foto {
        width: 35%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .destacado {
        position: absolute;
        width: 14px;
        height: 14px;
        background: #e5a688;
        top: 15px;
        left: 10px;
        border-radius: 50%;
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
        animation: heart-pulse 0.9s infinite ease-out;
      }

      .agotado {
        position: absolute;
        left: 0px;
        top: 0;
        width: 100%;
        height: 100%;
        font-size: 1.2em;
        border-radius: 10px;
        cursor: auto !important;
        pointer-events: none;
        background: #B97A91;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #fff;
        text-transform: uppercase;
        font-weight: bold;
        opacity: 0.85;
      }

    }
  }

  .modal-2 hr {
    border-color: #9A2D85;
  }

  .backbtn {
    cursor: pointer;
    padding: 10px;
  }

  .btn-comprar {
    background: #007bff;
    color: #fff;
    border: none;
    border-radius: 15px;
    padding: 5px 10px;
    font-size: 12px;
    display: block;
    width: 100px;
    margin-top: 5px;

    &:hover {
      background: #005580;
    }

    .fa {
      color: #fff;
      margin-left: 5px;
    }
  }

  .boton-chico {
    font-size: 12px;
    border-radius: 15px;
    padding: 5px 10px;
  }

  .old {
    text-decoration: line-through;
  }
}

.content-products {
  overflow-y: scroll;
  max-height: calc(100vh - 80px);
  height: 100%;

  .product-desktop {
    position: relative;
    display: flex;
    justify-content: center;

    img {
      position: relative;
      width: 100%;
      height: auto;
    }
  }

  .product-mobile {
    position: relative;
    display: none;

    img {
      position: relative;
      width: auto;
      margin-top: 5px;
    }
  }
}

@keyframes heart-pulse {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.2);
  }

  70% {
    transform: scale(0.65);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.2);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  50% {
    transform: scale(0.5);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  70% {
    transform: scale(2);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.5);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.ofertas_s {
  display: flex;
  flex-direction: column;

  a {
    margin: 5px auto;
  }

  @media only screen and (max-width: 480px) {
    flex-direction: row;
  }
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar {
  width: 7px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #555;
}

.no-offer {
  height: 80vh;
  display: flex;
  align-items: center;

  .txt-container {
    background-color: #218AFF;
    color: #fff;
    padding: 25px 40px;
    font-weight: 700;
    border-radius: 20px;
    box-shadow: 5px 5px 15px #00000040;

    @media(max-width:701px) {
      padding: 10px 20px;
    }
  }

  @media (max-width: 701px) {
    height: 200px;
  }
}
</style>